<template>
  <TableComp
    v-if="emailAliases"
    :name="$t('global.email-aliases')"
    :headers="headers"
    :status="emailAliases.status"
    :pagination="emailAliases.pagination"
    :sort="emailAliases.sort"
    :number-of-items="emailAliases.list.length"
    empty-image="email-aliases"
    :empty-bold-message="$t('global.no-email-aliases-bold-message')"
    :empty-message="$t('global.no-email-aliases-message')"
    v-on:update:list="updateList"
    :header-actions="actions"
    :empty-actions="getEmptyActions()"
  >
    <template #desktop>
      <tr v-for="emailAlias in emailAliases.list" v-bind:key="emailAlias.id">
        <td>
          <span class="mr-2">{{ emailAlias.email }}</span>
          <CopyToClipboard :text="emailAlias.email" />
        </td>

        <td class="text-center">
          <div v-for="(member, i) in emailAlias.members" :key="i">
            {{ member }}
          </div>
        </td>

        <td class="text-end actions">
          <div class="d-flex justify-content-end mr-4">
            <ThreeDotsMenu :items="menuItems(emailAlias)" />
          </div>
        </td>
      </tr>
    </template>
    <template #mobile>
      <TableMobileRow v-for="emailAlias in emailAliases.list" v-bind:key="emailAlias.id">
        <template #header>
          <div class="d-flex align-items-center">
            <!-- email alias email column -->
            <div class="flex-fill">
              <div class="d-flex align-items-center">
                <span class="mr-2">{{ emailAlias.email }}</span>
                <CopyToClipboard :text="emailAlias.email" />
              </div>
            </div>

            <!-- dropdown menu column -->
            <div>
              <div class="d-flex justify-content-center">
                <ThreeDotsMenu :items="menuItems(emailAlias)" />
              </div>
            </div>
          </div>
        </template>
        <template #content>
          <!-- email alias 'email' -->
          <div class="row">
            <div class="col">{{ $t("global.email") }}:</div>
            <div class="col">
              <span class="mr-2">{{ emailAlias.email }}</span>
              <CopyToClipboard :text="emailAlias.email" />
            </div>
          </div>

          <!-- email alias storage -->
          <div class="row">
            <div class="col">{{ $t("global.members") }}:</div>
            <div class="col">
              <div v-for="(member, i) in emailAlias.members" :key="i">
                {{ member }}
              </div>
            </div>
          </div>
        </template>
      </TableMobileRow>
    </template>
  </TableComp>
</template>

<script>
import CopyToClipboard from "@/components/display/CopyToClipboard";
import EmailAliasAddModal from "@/components/smart/modals/EmailAliasAdd";
import EmailAliasDeleteModal from "@/components/smart/modals/EmailAliasDelete";
import EmailAliasEditModal from "@/components/smart/modals/EmailAliasEdit";
import NavLink from "@/classes/NavLink";
import Status from "@/classes/Status";
import store from "@/store";
import TableComp from "@/components/display/table/TableComp";
import TableHeader from "@/classes/TableHeader";
import TableMobileRow from "@/components/display/table/TableMobileRow";
import ThreeDotsMenu from "@/components/display/ThreeDotsMenu";

export default {
  name: "EmailAliasesTable",
  props: {
    emailAliases: Object,
    site: {
      type: Object,
    },
    siteStatus: {
      type: Object,
      validator: (value) => {
        return value instanceof Status;
      },
    },
  },
  components: {
    TableComp,
    TableMobileRow,
    ThreeDotsMenu,
    CopyToClipboard,
  },
  setup(props, { root }) {
    const headers = [
      new TableHeader(root.$t("global.name")),
      new TableHeader(root.$t("global.members"), "justify-content-center"),
      new TableHeader(),
    ];

    const addEmailAlias = () => {
      store.dispatch("modals/open", {
        template: EmailAliasAddModal,
        data: { site: props.site },
      });
    };

    const updateEmailAlias = (emailAlias) => {
      store.dispatch("modals/open", {
        template: EmailAliasEditModal,
        data: { emailAlias, site: props.site },
      });
    };

    const deleteEmailAlias = (emailAlias) => {
      store.dispatch("modals/open", {
        template: EmailAliasDeleteModal,
        data: { emailAlias, site: props.site },
      });
    };

    const actions = [
      new NavLink(root.$t("global.add-email-alias"), "add", addEmailAlias, false, null, "epsilon"),
    ];

    const getEmptyActions = () => [
      new NavLink(
        root.$t("global.add-email-alias"),
        null,
        addEmailAlias,
        false,
        "primaryOutline",
        null
      ),
    ];

    const menuItems = (emailAlias) => {
      return [
        // regenerate password for email alias
        new NavLink(root.$t("global.update"), null, () => updateEmailAlias(emailAlias)),
        // delete email alias
        new NavLink(
          root.$t("global.delete"),
          null,
          () => deleteEmailAlias(emailAlias),
          null,
          "danger"
        ),
      ];
    };

    const updateList = (event) => {
      const { pagination, sort } = event;
      store.dispatch("emailAliases/getList", {
        siteId: props.site.id,
        pageIndex: pagination?.index,
        pageSize: pagination?.size,
        sortProperty: sort?.property,
        sortDirection: sort?.direction,
      });
    };

    return {
      getEmptyActions,
      headers,
      menuItems,
      updateList,
      actions,
    };
  },
};
</script>
